import React from 'react';
import { PRIORITIES, LABELS } from './taskData';

function TaskCard({ task, onDragStart, onDragEnd, onClick }) {
  const priority = PRIORITIES[task.priority];
  const taskLabels = LABELS.filter((l) => task.labels.includes(l.id));
  const subtasksDone = task.subtasks.filter((s) => s.done).length;
  const subtasksTotal = task.subtasks.length;

  return (
    <div
      className="tm-card"
      draggable
      onDragStart={(e) => onDragStart(e, task)}
      onDragEnd={onDragEnd}
      onClick={onClick}
    >
      <div className="tm-card-labels">
        {taskLabels.map((label) => (
          <span
            key={label.id}
            className="tm-card-label"
            style={{ background: label.color + '22', color: label.color }}
          >
            {label.name}
          </span>
        ))}
      </div>
      <h4 className="tm-card-title">{task.title}</h4>
      <div className="tm-card-meta">
        <span className="tm-card-priority" style={{ color: priority.color }}>
          {priority.icon} {priority.label}
        </span>
        {subtasksTotal > 0 && (
          <span className="tm-card-subtasks">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 11 12 14 22 4" />
              <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
            </svg>
            {subtasksDone}/{subtasksTotal}
          </span>
        )}
      </div>
      {subtasksTotal > 0 && (
        <div className="tm-card-progress">
          <div
            className="tm-card-progress-fill"
            style={{
              width: `${(subtasksDone / subtasksTotal) * 100}%`,
              background: priority.color,
            }}
          ></div>
        </div>
      )}
    </div>
  );
}

export default TaskCard;
